var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.668.163a.56.56 0 0 0 .002.783l2.427 2.452.056.05c.214.165.52.148.715-.051a.557.557 0 0 0-.002-.783L7.44.16l-.056-.05a.54.54 0 0 0-.716.052ZM.478 4.45A.551.551 0 0 0 0 5a.55.55 0 0 0 .545.553h9.589L6.67 9.054l-.05.057a.56.56 0 0 0 .048.726.54.54 0 0 0 .771.002l4.4-4.447.049-.056a.557.557 0 0 0 .07-.547.545.545 0 0 0-.504-.343H.545l-.068.005Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.77ffaf00362d52ab427c1c195c7b539f.svg";
export { ForwardRef as ReactComponent };